import { render, staticRenderFns } from "./DashboardOficiales.vue?vue&type=template&id=048b83ca"
import script from "./DashboardOficiales.vue?vue&type=script&lang=js"
export * from "./DashboardOficiales.vue?vue&type=script&lang=js"
import style0 from "./DashboardOficiales.vue?vue&type=style&index=0&id=048b83ca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports